export const RACK_WIDTH = 195
export const RACK_HEIGHT = 650
export const RACK_U_COUNT = 42
export const RACK_GAP = 20
export const RACK_PADDING_TOP = 9
export const RACK_PADDING_BOTTOM = 18
export const RACK_PADDING_LEFT = 9
export const RACK_PADDING_RIGHT = 9

export const U_HEIGHT = (RACK_HEIGHT - RACK_PADDING_TOP - RACK_PADDING_BOTTOM) / RACK_U_COUNT

export function rackBounds(rackIndex) {
  return {
    x: rackIndex * (RACK_WIDTH + RACK_GAP),
    y: 0,
    width: RACK_WIDTH,
    height: RACK_HEIGHT,
  }
}

export function nodeBounds(rackIndex, node) {
  const rack = rackBounds(rackIndex)
  const topU = node.index
  const heightU = node.uNumber
  return {
    x: rack.x + RACK_PADDING_LEFT,
    y: rack.y + RACK_PADDING_TOP + (RACK_U_COUNT - topU - 1) * U_HEIGHT,
    width: rack.width - RACK_PADDING_LEFT - RACK_PADDING_RIGHT,
    height: heightU * U_HEIGHT,
  }
}

export function sceneBounds(rackCount) {
  if (rackCount === 0) {
    return { width: RACK_WIDTH, height: RACK_HEIGHT }
  }
  const lastRack = rackBounds(rackCount - 1)
  return {
    width: lastRack.x + lastRack.width,
    height: RACK_HEIGHT,
  }
}
